module.exports = __webpack_public_path__ + "images/bannerPT-7ecf5fe48bf08ee56117a6998d5e2030.jpg";